import CloseIcon from '@mui/icons-material/Close';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { Button,DialogActions,DialogContent,DialogTitle,Stack,Typography } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { NewFormContext } from "../../../context/NewFormContext";
import { ChecklistSubitem,ChecklistType } from "../../../types/checklist/types";

type props = {
  open: boolean;
  handleCloseModal: Function;
  subitem: ChecklistSubitem
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function RemoveQrCode({ open, handleCloseModal, subitem }: props) {
  const { setModelo, modelo } = useContext(NewFormContext);
  const { t } = useTranslation('translation');

  function handelQrCode(eve: React.MouseEvent<HTMLButtonElement>) {
    delete modelo?.modeloQrCode;

    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === subitem.itemid
          ? {
            ...item,
            subitens: item.subitens.map((sub) =>
              sub.id === subitem.id
                ? { ...sub, geraQrCode: false }
                : sub
            ),
          }
          : item
      ),
    }));

    handleCloseModal();
  }

  return (
    <BootstrapDialog
      onClose={() => handleCloseModal()}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Deletar item
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleCloseModal()}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Stack direction='row' spacing={2} alignItems='center' justifyContent='flex-start' padding={2}>
          <ReportGmailerrorredIcon color="error" fontSize="large" />
          <Typography textAlign='left' fontWeight={600}>Todos os QR Codes gerados nas versões
            anteriores desse formulário serão permanentemente desabilitados, deseja prosseguir?</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handelQrCode}>
          {t('yes')}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
